import { getFileViewLogs } from '../../../api'
import { ReportTableModal } from '../../ReportTableModal'

import {
  FILE_VIEWS_REPORT_COLUMNS_CONFIG,
  FILE_VIEWS_REPORT_TAB,
} from './DocumentViewReportModal.constants'
import {
  getFileViewsReportItemsData,
  getFileViewsReportRequestParams,
} from './DocumentViewReportModal.utils'

function DocumentViewReportModal({ fileId, parentId, onClose }) {
  const tabs = [
    {
      columns: FILE_VIEWS_REPORT_COLUMNS_CONFIG,
      getItemsFromResponse: getFileViewsReportItemsData,
      getRequestParams: getFileViewsReportRequestParams(parentId),
      id: FILE_VIEWS_REPORT_TAB,
      loadItems: getFileViewLogs,
    },
  ]

  return (
    <ReportTableModal
      buttonCancelProps={{ text: 'Modal.ConfirmBtnKey' }}
      counterTextKey='Modal.FileViewsReportCounterKey'
      entityId={fileId}
      headerTextKey='Modal.FileViewsReportTitleKey'
      tabs={tabs}
      onClose={onClose}
    />
  )
}

export default DocumentViewReportModal
